module.exports = __webpack_public_path__ + "img/tip.d0dfea61.png";